module.exports = __webpack_public_path__ + "static/media/Taylor.97412e17.svg";